import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps extends React.PropsWithChildren {
  isOpen: boolean;
  height?: string;
  className?: string;
}

export const BottomDrawer: React.FC<IProps> = ({
  children,
  isOpen = false,
  height = "auto",
  className,
}) => {
  return (
    <Column
      className={cn(
        isOpen ? "translate-y-0" : "translate-y-full",
        "overflow-auto",
        "fixed",
        "right-0",
        "bottom-0",
        "w-full",
        "min-height",
        "min-h-200px",
        "text-core-text-default",
        "bg-core-surface-inverse",
        "transition-transform",
        `duration-[400ms]`,
        "shadow-lg",
        "z-101",
        className
      )}
      onClick={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        height,
        boxShadow: `5px 1px 4px ${Core.surface.default}`,
      }}
    >
      {children}
    </Column>
  );
};
